module.exports = __webpack_public_path__ + "static/media/super_saver.5cae1772.jpg";